"use client";

import { useEffect, useId } from "react";

const SheKnowsAd = ({ type, id: propId }) => {
  const reactId = useId();
  const myId = propId || `skm-ad-${type}-${reactId.replace(/:/g, "")}`;

  useEffect(() => {
    if (typeof window !== "undefined" && window.blogherads) {
      window.blogherads.adq.push([type, myId]);
    }
    return () => {
      if (
        typeof window === "undefined" ||
        !window.blogherads ||
        typeof window.blogherads.destroySlots !== "function"
      ) {
        return;
      }
      // The ad script throws if its slot map is not ready yet. That throw
      // escapes the effect cleanup and replaces the page with the error screen.
      try {
        window.blogherads.destroySlots([myId]);
      } catch (error) {
        console.error("SheKnows ad slot cleanup failed", error);
      }
    };
  }, [type, myId]);

  return <div id={myId}></div>;
};

export default SheKnowsAd;
